/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import { ReduceStore } from 'flux/utils'
import { List, Record } from 'immutable'
import AppDispatcher from '../../core/AppDispatcher'
import MonthlyClosingEvent from '../../event/MonthlyClosingEvent'
import { DailyClosingHeadState } from '../state/DailyClosingHeadState'

const ViewState = Record({
  occupancy_dates: 0,
  daily_closings: List()
})

class DailyClosingHeadsStore extends ReduceStore {
  constructor() {
    super(AppDispatcher)
  }

  getInitialState() {
    return ViewState()
  }

  reduce(state, action) {
    const payload = action.payload

    switch (action.type) {
      case MonthlyClosingEvent.showDetail:
        const heads = payload.daily_closings.map(head => {
          return new DailyClosingHeadState().mergeModel(head)
        })
        return state.merge({ daily_closings: heads, occupancy_dates: payload.occupancy_dates })

      default:
        return state
    }
  }
}

export default new DailyClosingHeadsStore()
